export default "__VITE_ASSET__DvWrbAEj__"